// extracted by mini-css-extract-plugin
export var centered = "metadata-module--centered--2VWxP";
export var grey = "metadata-module--grey--+vPNb";
export var icon = "metadata-module--icon--Ig03L";
export var item = "metadata-module--item--UqdLK";
export var white = "metadata-module--white---+Acf";
export var wrapper = "metadata-module--wrapper--s8rgC";